import QUERY_PRESERVE_PARAMS, { QUERY_NOT_REQUIRED_FETCH } from "@utils/utm";

if (typeof window !== "undefined") {
  const constantMock = window.fetch;
  // eslint-disable-next-line func-names
  window.ackoFetch = function(...args) {
    const copyArgs = [...args];
    const urlParams = new URLSearchParams(window.location.search);

    let apiUrl;
    try {
      apiUrl = new URL(args[0]);
    } catch (error) {
      apiUrl = new URL(`http://dummydomain.com${args[0]}`);
    }
    // const myParam = urlParams.get("myParam");
    let xlpModified = "";

    QUERY_PRESERVE_PARAMS.forEach(item => {
      if (QUERY_NOT_REQUIRED_FETCH.includes(item)) return;
      const value = urlParams.get(item);

      if (value) {
        apiUrl.searchParams.append(item, value);
        if (item === "source") {
          xlpModified = `/lp/${value}`;
        }
      }
    });
    copyArgs[0] = apiUrl.href.replace("http://dummydomain.com", "");
    copyArgs[1] = copyArgs[1] || { headers: {} };
    copyArgs[1].headers = copyArgs[1].headers || {};
    // copyArgs[1].headers["custom-cookie"] = document.cookie;
    // copyArgs[1].headers["x-tracker-id"] = "1234";
    // copyArgs[1].headers["x-user-id"] = "1422922";
    copyArgs[1].headers["cookie"] = document.cookie;
    copyArgs[1].headers["x-landing-path"] =
      window.basePath || "/lp/new-comprehensive";
    copyArgs[1].headers["x-landing-url"] = window.location.href;
    copyArgs[1].headers["x-app-name"] = "falcon";
    copyArgs[1].credentials = "include";
    // copyArgs[1].headers["x-tracker-id"] = "1234";

    // TODO: REMOVE THIS BEFORE MERGING *****
    // copyArgs[1].headers["x-user-id"] = "1051495";

    // TODO : TO BE REMOVED ALERT:
    // copyArgs[1].headers["x-tracker-id"] = "12345";
    // copyArgs[1].headers["x-user-id"] = "12345";

    // TODO new-changes for new-car
    // copyArgs[1].headers["initiator"] = "storefront";

    if (xlpModified) {
      copyArgs[1].headers["x-modified-landing-path"] = xlpModified;
    }

    return Promise.race([
      constantMock.apply(this, copyArgs),
      new Promise((_resolve, reject) => {
        setTimeout(() => {
          reject(new Error("API timeout error."));
        }, 20_000);
      })
    ]);
  };
}
